import { useMemo, useRef, useState } from 'react'
import { Block, Image } from '@/components/crRender'
import placeholderImg from "@assets/placeholders/doctor-placeholder.png"
import ActionBtn from '@/components/ActionBtn'
import './style.css'
import ImgPopup from '@/components/popups/imgPopup'
import { FileUpload } from '@/components/Exporter'

const getLogo = (Logo) => {
    return {
        Logo: Logo?.data[Logo?.data?.length - 1]?.name ? window.API_URL + Logo?.data[Logo?.data?.length - 1]?.name : null,
        sourcePath: window.API_URL,
        LogoData: Logo?.data[Logo?.data?.length - 1]
    }
}

const ImgProfile = ({ logo, value, setValue, formHandler }) => {

    const [isEditImg, setIsEditImg] = useState(false)


    const showImg = useRef(false)

    const LogoLinks = useMemo(() => logo[0]?.data?.length > 0 ? getLogo(logo[0]) : "", [logo])

    const handleShowImg = () => {
        showImg.current.click()
    }


    const handleImgView = () => {
        setIsEditImg(true)
        handleImgDelete(LogoLinks?.LogoData?.id)
    }


    const handleImgDelete = () => {
        formHandler?.handleFormValues('removedId', {
            value: LogoLinks?.LogoData?.id,
            isRequired: false,
            isError: false
        })
    }



    return (
        <>
            <div className="technology-item-card  col-lg-6 mb-2" >
                <Block isRender={!isEditImg} className="profile-img-container">
                    <div className=''>
                        <div className="relative-container">
                            <Image onClick={() => handleShowImg()} placeholder={placeholderImg} src={`${LogoLinks.Logo}`} />
                            <ActionBtn
                                icon="carbon:close-filled"
                                className="remove-tech-btn remove-tech-image-btn pointer"
                                onApply={handleImgView} />
                        </div>

                    </div>
                </Block>
                <Block isRender={!!isEditImg}>
                    <FileUpload
                        className="col-lg-12 field-img-profile"
                        name="logo"
                        accept="image/*"
                        maxFiles={1}
                        value={value}
                        setValue={setValue}
                    />
                </Block>
            </div>
            <ImgPopup
                link={LogoLinks.link}
                refImg={showImg}
                sourcePath={LogoLinks.sourcePath}
                isHideText
            />
        </>
    )
}

export default ImgProfile